"use client";

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

type StructureStepProps = {
  operatesMultipleBrands: boolean;
  onChange: (value: boolean) => void;
};

export function WorkspaceStructureStep({
  operatesMultipleBrands,
  onChange,
}: StructureStepProps) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-base font-semibold">How does your agency trade?</h3>
        <p className="mt-1 text-sm text-muted-foreground">
          This helps us avoid asking for the same logo, country, and timezone
          twice when you only operate under one brand.
        </p>
      </div>

      <label className="flex cursor-pointer items-start gap-3 rounded-lg border p-4 hover:bg-muted/30">
        <Checkbox
          checked={operatesMultipleBrands}
          onCheckedChange={(checked) => onChange(checked === true)}
          className="mt-0.5"
        />
        <div className="space-y-1">
          <Label className="cursor-pointer text-sm font-medium leading-snug">
            We operate under more than one brand
          </Label>
          <p className="text-sm text-muted-foreground">
            Separate trading names with their own logos, currencies, or customer
            identities. You&apos;ll set up each brand individually after workspace
            basics.
          </p>
        </div>
      </label>

      {!operatesMultipleBrands ? (
        <p className="rounded-md bg-muted/40 px-3 py-2 text-sm text-muted-foreground">
          Single-brand mode: workspace details you enter next will prefill your
          first brand setup.
        </p>
      ) : null}
    </div>
  );
}
